import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyFunctions } from '@app/_helpers';
import { BoxplotService, InformeProyectosService, MaquinasService, MenuService, UsuariosService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { CellClickEvent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { first } from 'rxjs/operators';
import * as d3 from 'd3';
import {nest} from 'd3-collection';
import { style } from '@angular/animations';

@Component({
  selector: 'app-operaciones-boxplot',
  templateUrl: './operaciones-boxplot.component.html'
})
export class OperacionesBoxplotComponent implements OnInit {

  user = this.userService.userValue;

  //Para saber cuándo dibujar cosas o cuándo cargar círculo cargando
  public loadingDatos: boolean = true;
  public tieneDatos: boolean = true;
  
  //For filter
  public hayDatosFiltro: boolean = false;

  public listaClientes: any;
  public clientesSeleccionados: any;

  public fechaIni: Date;
  public fechaFin: Date;

  public listaPiezas: any;
  public piezasSeleccionadas: any;

  public listaPartes: any; 
  public partesSeleccionadas: any;

  public listaOfs: any;
  public ofsSeleccionados: any;

  //Datos completos del filtro
  private dataFiltro: any;

  //Datos grid
  public dataInforme: any;
  private dataTabla: any;
  private dataBoxplot: any;

  //PARA AÑADIR PAGGING AL GRID
  public skip = 0;

  //Para gráficas
  // set the dimensions and margins of the graph
  private margin;
  private width;
  private height;
  private svg; //gráficas

  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  constructor(private informeProyectosService: InformeProyectosService,
    private userService: UsuariosService,
    public router: Router, public route: ActivatedRoute,
    private menuService: MenuService,
    private translateService: TranslateService,
    private myFunctions: MyFunctions,
    private boxplotService: BoxplotService) { 
    
    this.menuService.titulo = this.translateService.instant('informes-boxplot').toUpperCase();
    this.userService.user.subscribe(x => this.user = x);
  }

  ngOnInit(): void {
    this.cargarDatosFiltro(); //al iniciar la vista se cargan los datos del filtro lo primero, este no habilita sus botones hasta que tiene los datos cargados
  }

  // Si cambian la fecha de inicio o final ponerles las horas
  public onChangeFechaIni(value: Date): void {
    if (value == null) this.fechaIni = undefined;
    else this.fechaIni.setHours(0, 0, 0);
  }

  public onChangeFechaFin(value: Date): void {
    if (value == null) this.fechaFin = undefined;
    else this.fechaFin.setHours(0, 0, 0);
  }

  public showGridTooltip(e: MouseEvent): void { //para mostrar un tooltip con el dato al pasar el ratón por encima cuando el título o contenido no cabe
    const element = e.target as HTMLElement;
    if ((element.nodeName === 'TD' || element.nodeName === 'TH' || element.nodeName === 'SPAN')
      && element.offsetWidth < element.scrollWidth) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }

  CambioFiltro(): void { //si los datos del filtro cambian actualizar cuáles son los datos seleccionados

    var data: any = this.dataFiltro;

    var idsOFs = [];
    if (this.ofsSeleccionados != undefined)
      this.ofsSeleccionados.forEach(of => idsOFs.push(of.idOf));

    var idsClientes = [];
    if (this.clientesSeleccionados != undefined)
      this.clientesSeleccionados.forEach(cliente => idsClientes.push(cliente.idCliente));

    var idPiezas = [];
    if (this.piezasSeleccionadas != undefined)
      this.piezasSeleccionadas.forEach(pieza => idPiezas.push(pieza.nombrePieza));

    var idPartes = [];
    if (this.partesSeleccionadas != undefined)
      this.partesSeleccionadas.forEach(parte => idPartes.push(parte.nombreParte));

    var groupByCliente = [];
    var groupByPieza = [];
    var groupByOf = [];
    var groupByParte = [];

    //GROUP BY OF
    var lag: any = {};
    data.forEach(
      row => {
        if (!lag[row.idOf]
          && (idsClientes.includes(row.idCliente) || idsClientes[0] == undefined)
          && (idPiezas.includes(row.nombrePieza) || idPiezas[0] == undefined)
          && (idPartes.includes(row.nombreParte) || idPartes[0] == undefined)
        ) {
          lag[row.idOf] = { idOf: row.idOf, nombreOf: row.nombreOf };
          groupByOf.push(lag[row.idOf]);
        }
      });

    this.listaOfs = groupByOf.filter(item => (item.idOf != -1));
    this.listaOfs.sort((a, b) => (a.nombreOf > b.nombreOf) ? 1 : ((b.nombreOf > a.nombreOf) ? -1 : 0));

    //GROUP BY CLIENTE
    lag = {};
    data.forEach(
      row => {
        if (!lag[row.idCliente]
          && (idsOFs.includes(row.idOf) || idsOFs[0] == undefined)
          && (idPiezas.includes(row.nombrePieza) || idPiezas[0] == undefined)
          && (idPartes.includes(row.nombreParte) || idPartes[0] == undefined)
        ) {
          lag[row.idCliente] = {
            idCliente: row.idCliente, nombreCliente: row.nombreCliente,
          };
          groupByCliente.push(lag[row.idCliente]);
        }
      });

    this.listaClientes = groupByCliente.filter(item => (item.idCliente != -1));
    this.listaClientes.sort((a, b) => (a.nombreCliente > b.nombreCliente) ? 1 : ((b.nombreCliente > a.nombreCliente) ? -1 : 0));


    //GROUP BY PIEZA
    lag = {};
    data.forEach(
      row => {
        if (!lag[row.nombrePieza]
          && (idsOFs.includes(row.idOf) || idsOFs[0] == undefined)
          && (idsClientes.includes(row.idCliente) || idsClientes[0] == undefined)
          && (idPartes.includes(row.nombreParte) || idPartes[0] == undefined)) {
          lag[row.nombrePieza] = {
            idPieza: row.idPieza, nombrePieza: row.nombrePieza,
          };
          groupByPieza.push(lag[row.nombrePieza]);
        }
      });

    this.listaPiezas = groupByPieza.filter(item => (item.idPieza != -1));
    this.listaPiezas.sort((a, b) => (a.nombrePieza > b.nombrePieza) ? 1 : ((b.nombrePieza > a.nombrePieza) ? -1 : 0));

    //GROUP BY PARTE
    lag = {};
    data.forEach(
      row => {
        if (!lag[row.nombreParte]
          && (idsOFs.includes(row.idOf) || idsOFs[0] == undefined)
          && (idsClientes.includes(row.idCliente) || idsClientes[0] == undefined)
          && (idPiezas.includes(row.nombrePieza) || idPiezas[0] == undefined)) {
          lag[row.nombreParte] = {
            idParte: row.idParte, nombreParte: row.nombreParte,
          };
          groupByParte.push(lag[row.nombreParte]);
        }
      });

  
    this.listaPartes = groupByParte.filter(item => (item.idParte != -1 && item.nombreParte !== ""));
    this.listaPartes.sort((a, b) => (a.nombreParte > b.nombreParte) ? 1 : ((b.nombreParte > a.nombreParte) ? -1 : 0));
    
  }

  btnLimpiarFiltro(): void { //si se quiere limpiar el filtro vaciar todo

    this.ofsSeleccionados = undefined;
    this.clientesSeleccionados = undefined;
    this.piezasSeleccionadas = undefined;
    this.partesSeleccionadas = undefined;
    this.CambioFiltro();

  }

  cargarDatosInforme(): void {

    this.loadingDatos = true; //se están cargando los datos, mostrar barra de carga
    var r1, r2: boolean = false; //aún no se tiene ninguna respuesta

    //Cogemos los datos para la llamada de los seleccionados en el filtro
    var listaNombresClientes = (this.clientesSeleccionados === undefined) ? [] : this.clientesSeleccionados.map(a => a.nombreCliente);
    var listaNombresPiezas = (this.piezasSeleccionadas === undefined) ? [] : this.piezasSeleccionadas.map(a => a.nombrePieza);
    var listaNombresOfs = (this.ofsSeleccionados === undefined) ? [] : this.ofsSeleccionados.map(a => a.nombreOf);
    var listaPartes = (this.partesSeleccionadas === undefined) ? [] : this.partesSeleccionadas.map(a => a.nombreParte);
    var fechaInicio = (this.fechaIni === undefined) ? undefined : this.myFunctions.dateToYYYYMMDDtHHmmSSz(this.fechaIni);
    var fechaFin = (this.fechaFin === undefined) ? undefined : this.myFunctions.dateToYYYYMMDDtHHmmSSz(this.fechaFin);

    //Tomar datos piezas para tabla
    this.boxplotService.GetInformeTabla(fechaInicio, fechaFin, listaNombresClientes.join("&"), listaNombresPiezas.join("&"), listaNombresOfs.join("&"), listaPartes.join("&"), "", "", "", "", 1).pipe(first()).subscribe(
      (result: any) => {
        this.dataTabla = result.data;
        r1 = true; // respuesta 1 recibida
        if (r1 && r2){
          this.procesarDatos(); //si se tienen las dos respuestas procesar los datos
        }
      });

     this.boxplotService.GetInformeOperacionesBoxplots(fechaInicio, fechaFin, listaNombresClientes.join("&"), listaNombresPiezas.join("&"), listaNombresOfs.join("&"), listaPartes.join("&"), "", "", "", "", 1).pipe(first()).subscribe(
        (result: any) => {
          this.dataBoxplot= result.data;
          r2 = true; // respuesta 2 recibida
          if (r1 && r2){
            this.procesarDatos(); //si se tienen las dos respuestas procesar los datos
          } 
        }); 
  }

  procesarDatos(): void{
    if (this.dataTabla !== undefined && this.dataTabla !== null){ //si tenemos los datos de la tabla, los ordenamos (si no había datos podía devolvernos un null)
      this.dataInforme = this.dataTabla.sort((a, b) => {
        // Create the dates
        var keyA = a.nombreOperacion,
          keyB = b.nombreOperacion;
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    } 
    if (this.dataBoxplot !== undefined && this.dataBoxplot !== null){ //si tenemos los datos del boxplot, los ordenamos (si no había datos podía devolvernos un null)
      this.dataBoxplot = this.dataBoxplot.sort((a, b) => {
        // Create the dates
        var keyA = a.nombreOperacion,
          keyB = b.nombreOperacion;
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      }); 
    }

    this.loadingDatos = false; //ya no se están cargando los datos
    //Ponemos el skip a 0 para mandar el grid a la primera pagina
    this.skip = 0;
    if (this.dataInforme !== null && this.dataInforme.length > 0) { //si los datos de la tabla incluyen al menos una pieza
      this.tieneDatos = true; //hay datos para dibujar los boxplots
      //eliminar boxplots anteriores, de existir
      var nodes = document.getElementById('graficoEstimadoReal_BoxplotOperaciones').childNodes;
      for(var i=0; i<nodes.length; i++) {
          if (nodes[i].nodeName.toLowerCase() === 'svg') {
              nodes[i].remove();
          }
      }
      var nodes = document.getElementById('graficoPredictivoReal_BoxplotOperaciones').childNodes;
      for(var i=0; i<nodes.length; i++) {
          if (nodes[i].nodeName.toLowerCase() === 'svg') {
              nodes[i].remove();
          }
      }
      //Cargar nuevos boxplots
      this.cargarGraficaEstimadoPredictivoReal(false);
      this.cargarGraficaEstimadoPredictivoReal(true);
    } else { //si los datos de la tabla no incluyen ninguna pieza, seguir cargando los boxplots
      this.tieneDatos = false;
    } 
  }

  cargarDatosFiltro(): void { //tomar datos para filtro

    //Si existen los parámetros, asignar las fechas de los parámetros, sino las fechas de hoy
    if (Object.getOwnPropertyNames(this.route.snapshot.params).length !== 0){
      this.fechaIni = new Date(String(this.route.snapshot.params.fechaIni.replace(/_/g, "-")));
      this.fechaFin = new Date(String(this.route.snapshot.params.fechaFin.replace(/_/g, "-"))); 
      this.fechaIni.setHours(0, 0, 0);
      this.fechaFin.setHours(0, 0, 0);
    } else {
      this.fechaIni = new Date(this.myFunctions.getDateNow().getTime() - (6 * 24 * 60 * 60 * 1000)); //tomamos la fecha actual y echamos atrás seis días
      this.fechaFin = this.myFunctions.getDateNow();
      this.fechaIni.setHours(0, 0, 0);
      this.fechaFin.setHours(0, 0, 0);
    }
    
    //se toman los datos
    this.informeProyectosService.Get_ClientesPiezasOfsOperacionesPartes().pipe(first()).subscribe((data: any) => {

      this.dataFiltro = data;

      if (this.route.snapshot.params !== undefined){
        var scope = this;
        var filtrado = data.filter(function(elem) {return elem.idCliente === Number(scope.route.snapshot.params.idCliente);});
        this.clientesSeleccionados = [{idCliente: Number(this.route.snapshot.params.idCliente), nombreCliente: filtrado[0].nombreCliente}];
        filtrado = data.filter(function(elem) {return elem.idOf === Number(scope.route.snapshot.params.idOF);});
        this.ofsSeleccionados = [{idOf: Number(this.route.snapshot.params.idOF), nombreOf: filtrado[0].nombreOf}];
        filtrado = data.filter(function(elem) {return elem.idPieza === Number(scope.route.snapshot.params.idPieza);});
        this.piezasSeleccionadas = [{idPieza: Number(this.route.snapshot.params.idPieza), nombrePieza: filtrado[0].nombrePieza}];
        if (!this.user.ocultarParte){
          filtrado = data.filter(function(elem) {return elem.idParte === Number(scope.route.snapshot.params.idParte);});
          this.partesSeleccionadas = [{idParte: Number(this.route.snapshot.params.idParte), nombreParte: filtrado[0].nombreParte}];
        }
      } 

      var groupByCliente = [];
      var groupByPieza = [];
      var groupByOf = [];
      var groupByParte = [];

      //GROUP BY CLIENTE
      data.forEach(function (a) {
        if (!this[a.idCliente]) {
          this[a.idCliente] = {
            idCliente: a.idCliente, nombreCliente: a.nombreCliente,
          };
          groupByCliente.push(this[a.idCliente]);
        }
      }, Object.create(null));

      this.listaClientes = groupByCliente.filter(item => (item.idCliente != -1));;
      this.listaClientes.sort((a, b) => (a.nombreCliente > b.nombreCliente) ? 1 : ((b.nombreCliente > a.nombreCliente) ? -1 : 0))

      //GROUP POR PIEZA
      data.forEach(function (a) {
        if (!this[a.nombrePieza]) {
          this[a.nombrePieza] = {
            idPieza: a.idPieza, nombrePieza: a.nombrePieza,
          };
          groupByPieza.push(this[a.nombrePieza]);
        }
      }, Object.create(null));

      this.listaPiezas = groupByPieza.filter(item => (item.idPieza != -1));
      this.listaPiezas.sort((a, b) => (a.nombrePieza > b.nombrePieza) ? 1 : ((b.nombrePieza > a.nombrePieza) ? -1 : 0))

      //GROUP POR PARTE
      data.forEach(function (a) {
        if (!this[a.nombreParte]) {
          this[a.nombreParte] = {
            idParte: a.idParte, nombreParte: a.nombreParte,
          };
          groupByParte.push(this[a.nombreParte]);
        }
      }, Object.create(null));

      
      this.listaPartes = groupByParte.filter(item => (item.idParte != -1 && item.nombreParte !== ""));
      this.listaPartes.sort((a, b) => (a.nombreParte > b.nombreParte) ? 1 : ((b.nombreParte > a.nombreParte) ? -1 : 0));

      //GROUP BY OF
      data.forEach(function (a) {
        if (!this[a.idOf]) {
          this[a.idOf] = {
            idOf: a.idOf, nombreOf: a.nombreOf,
          };
          groupByOf.push(this[a.idOf]);
        }
      }, Object.create(null));

      this.listaOfs = groupByOf.filter(item => (item.idOf != -1));
      this.listaOfs.sort((a, b) => (a.nombreOf > b.nombreOf) ? 1 : ((b.nombreOf > a.nombreOf) ? -1 : 0))

      this.hayDatosFiltro = true; //ya están cargados los datos del filtro, los botones se pueden habilitar

      this.cargarDatosInforme(); //cargar la tabla y boxplots

    });

  }

  cargarGraficaEstimadoPredictivoReal(predictiva: boolean): void{ //función para dibujar las gráficas
    //Define variables
    var q1, median, q3, interQuantileRange, min, max;
    // el margin y el height es igual para ambas, pero el width cambiará dependiendo de las piezas que tengamos y hay que asignárselo por separado a cada una
    this.margin = {top: 50, right: 10, bottom: 50, left: 40};
    if (predictiva){
      var auxWidth;
      if (this.dataInforme.length * 100 > 1500){
        auxWidth = 1500;
      } else {
        auxWidth = this.dataInforme.length * 100;
      }
      this.width = auxWidth - this.margin.left - this.margin.right;
    } else {
      var auxWidth;
      if (this.dataInforme.length * 100 > 1500){
        auxWidth = 1500;
      } else {
        auxWidth = this.dataInforme.length * 100;
      }
      this.width = auxWidth - this.margin.left - this.margin.right;
    }
    this.height = 250 - this.margin.top - this.margin.bottom;

    if (predictiva){
      // append the svg object to the body of the page
      this.svg = d3.select("#graficoPredictivoReal_BoxplotOperaciones")
                   .append("svg")
                   .attr("width", this.width + this.margin.left + this.margin.right)
                   .attr("height", this.height + this.margin.top + this.margin.bottom)
                   .append("g")
                   .attr("transform","translate(" + this.margin.left + "," + this.margin.top + ")");
      // Compute quartiles, median, inter quantile range min and max --> these info are then used to draw the box.
      var sumstat = nest() // nest function allows to group the calculation per level of a factor
                    .key(function(d) { return d.nombreOperacion;})
                    .rollup(function(d) {
                      q1 = d3.quantile(d.map(function(g) { return g.porcenDesvioPredictivo;}).sort(d3.ascending),0.25);                    
                      median = d3.quantile(d.map(function(g) { return g.porcenDesvioPredictivo;}).sort(d3.ascending),0.5);
                      q3 = d3.quantile(d.map(function(g) { return g.porcenDesvioPredictivo;}).sort(d3.ascending),0.75);
                      interQuantileRange = q3 - q1;
                      min = q1 - 1.5 * interQuantileRange;
                      max = q3 + 1.5 * interQuantileRange;
                      return({q1: q1, median: median, q3: q3, interQuantileRange: interQuantileRange, min: min, max: max})
                    })
                    .entries(this.dataBoxplot);
    } else {
      // append the svg object to the body of the page
      this.svg = d3.select("#graficoEstimadoReal_BoxplotOperaciones")
                   .append("svg")
                   .attr("width", this.width + this.margin.left + this.margin.right)
                   .attr("height", this.height + this.margin.top + this.margin.bottom)
                   .append("g")
                   .attr("transform","translate(" + this.margin.left + "," + this.margin.top + ")");
      // Compute quartiles, median, inter quantile range min and max --> these info are then used to draw the box.
      var sumstat = nest() // nest function allows to group the calculation per level of a factor
                    .key(function(d) { return d.nombreOperacion;})
                    .rollup(function(d) {
                      q1 = d3.quantile(d.map(function(g) { return g.porcenDesvio;}).sort(d3.ascending),0.25);                    
                      median = d3.quantile(d.map(function(g) { return g.porcenDesvio;}).sort(d3.ascending),0.5);
                      q3 = d3.quantile(d.map(function(g) { return g.porcenDesvio;}).sort(d3.ascending),0.75);
                      interQuantileRange = q3 - q1;
                      min = q1 - 1.5 * interQuantileRange;
                      max = q3 + 1.5 * interQuantileRange;
                      return({q1: q1, median: median, q3: q3, interQuantileRange: interQuantileRange, min: min, max: max})
                    })
                    .entries(this.dataBoxplot);
    }
    
    var auxList = []; // create aux variable to get list of pieces
    this.dataBoxplot.map(function(d) { if (!auxList.includes(d.nombreOperacion)){auxList.push(d.nombreOperacion);}});
    auxList.sort((a, b) => { //ordenar la lista con mismo orden que en tabla
      // Create the dates
      var keyA = a.nombreOperacion,
        keyB = b.nombreOperacion;
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    // Show the X scale
    var x = d3.scaleBand()
              .range([ 0, this.width ])
              .domain(auxList)
              .paddingInner(1)
              .paddingOuter(.5);

    this.svg.append("g")
            .attr("transform", "translate(0," + this.height + ")")
            .call(d3.axisBottom(x));

    //calcular dominio escala y
    var minD, maxD;
    var minimos = sumstat.map(function(d) {return d.value.min;});
    var maximos = sumstat.map(function(d) {return d.value.max;});
    minD = Math.min.apply(null, minimos), maxD = Math.max.apply(null, maximos);
        
    // Show the Y scale
    var y = d3.scaleLinear()
              .domain([minD - 10,maxD + 10])
              .range([this.height, 0]);

    this.svg.append("g").call(d3.axisLeft(y));

    // Show the main vertical line
    this.svg.selectAll("vertLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", function(d){return(x(d.key))})
            .attr("x2", function(d){return(x(d.key))})
            .attr("y1", function(d){return(y(d.value.min))})
            .attr("y2", function(d){return(y(d.value.max))})
            .attr("stroke", "grey")
            .attr("class", "boxplotLines")
            .style("width", 50);

    // rectangle for the main box
    var boxWidth = 50;
    
    this.svg.selectAll("boxes")
            .data(sumstat)
            .enter()
            .append("rect")
            .attr("x", function(d){return(x(d.key)-boxWidth/2)})
            .attr("y", function(d){return(y(d.value.q3))})
            .attr("height", function(d){return(y(d.value.q1)-y(d.value.q3))})
            .attr("width", boxWidth )
            .attr("stroke", "white")
            .attr("class", "boxplotLines")
            .style("fill", "#22c4c4");

    // Show the median
    this.svg.selectAll("medianLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", function(d){return(x(d.key)-boxWidth/2) })
            .attr("x2", function(d){return(x(d.key)+boxWidth/2) })
            .attr("y1", function(d){return(y(d.value.median))})
            .attr("y2", function(d){return(y(d.value.median))})
            .attr("stroke", "white")
            .attr("class", "boxplotLines")
            .style("width", 40);

    // Show the bottom line
    this.svg.selectAll("horizLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", function(d){return(x(d.key) - boxWidth/4) })
            .attr("x2", function(d){return(x(d.key) + boxWidth/4) })
            .attr("y1", function(d){return(y(d.value.min))})
            .attr("y2", function(d){return(y(d.value.min))})
            .attr("stroke", "grey")
            .attr("class", "boxplotLines")
            .style("width", 40);

    // Show the top line
    this.svg.selectAll("horizLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", function(d){return(x(d.key) - boxWidth/4) })
            .attr("x2", function(d){return(x(d.key) + boxWidth/4) })
            .attr("y1", function(d){return(y(d.value.max))})
            .attr("y2", function(d){return(y(d.value.max))})
            .attr("stroke", "grey")
            .attr("class", "boxplotLines")
            .style("width", 40);

    // Add individual points with jitter
    var jitterWidth = 50;

    if (predictiva){
      // Define the div for the tooltip
      var div = d3.select("#boxplot-tooltip2Operaciones")		
                  .style("visibility", "hidden")
                  .style("position", "absolute");
      
      var scope = this;         
      this.svg.selectAll("indPoints")
              .data(this.dataBoxplot)
              .enter()
              .append("circle")
              .attr("cx", function(d){return(x(d.nombreOperacion) - jitterWidth/2 + Math.random()*jitterWidth )})
              .attr("cy", function(d){return(y(d.porcenDesvioPredictivo))})
              .attr("r", 4)
              .style("fill", "white")
              .attr("stroke", "black")
              .attr("class", "boxplotLines")
              .on("mouseover", function(evt, d) {	//on mouse over change tooltip content and add new content of circle
                var coordinates= d3.pointer(evt);
                var x = coordinates[0] + 50;
                var y = coordinates[1] + 50;
                var tooltipContent = '';
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("nserie").toUpperCase()}: </span><span class="tooltip-valor">${d.nSerie}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("fecha").toUpperCase()}: </span><span class="tooltip-valor">${d.fechaIni.split("T")[0]}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("horasPredictivas").toUpperCase()}: </span><span class="tooltip-valor">${d.tiempoPredictivoTotal}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("horasReales").toUpperCase()}: </span><span class="tooltip-valor">${d.tiempoTotal}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("%").toUpperCase()}: </span><span class="tooltip-valor">${d.porcenDesvioPredictivo}<br></span></p>`;
                div.transition()		
                   .duration(200)		
                   .style("visibility", "visible");		
                   div.html(tooltipContent)	
                .style('transform', `translate(${x}px, ${y}px)`);
              })					
              .on("mouseout", function(evt, d) {		//on mouse out hide tooltip
                div.transition()		
                   .duration(500)		
                   .style("visibility", "hidden");	
              })
              .on("click", function(evt, d){ //on mouse click go to historico procesos
                window.open('#/historicoProcesos/' + d.idHistorico_piezas + "/" + d.idHistoricoOperacion + "/" + scope.myFunctions.dateToYYYY_MM_DD(scope.fechaIni) + '/' + scope.myFunctions.dateToYYYY_MM_DD(scope.fechaFin) + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0', '_blank');
              });;
    } else {
      // Define the div for the tooltip
      var div = d3.select("#boxplot-tooltip1Operaciones")		
                  .style("visibility", "hidden")
                  .style("position", "absolute");
            
      var scope = this;        
      this.svg.selectAll("indPoints")
              .data(this.dataBoxplot)
              .enter()
              .append("circle")
              .attr("cx", function(d){return(x(d.nombreOperacion) - jitterWidth/2 + Math.random()*jitterWidth )})
              .attr("cy", function(d){return(y(d.porcenDesvio))})
              .attr("r", 4)
              .style("fill", "white")
              .attr("stroke", "black")
              .attr("class", "boxplotLines")
              .on("mouseover", function(evt, d) {		
                var coordinates= d3.pointer(evt);
                var x = coordinates[0] + 50;
                var y = coordinates[1] + 50;
                var tooltipContent = '';
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("nserie").toUpperCase()}: </span><span class="tooltip-valor">${d.nSerie}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("fecha").toUpperCase()}: </span><span class="tooltip-valor">${d.fechaIni.split("T")[0]}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("horasEstimadas").toUpperCase()}: </span><span class="tooltip-valor">${d.tiempoEstimadoTotal}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("horasReales").toUpperCase()}: </span><span class="tooltip-valor">${d.tiempoTotal}<br></span></p>`;
                tooltipContent +=`<p><span class="tooltip-title">${scope.translateService.instant("%").toUpperCase()}: </span><span class="tooltip-valor">${d.porcenDesvio}<br></span></p>`;
                div.transition()		
                   .duration(200)		
                   .style("visibility", "visible");		
                   div.html(tooltipContent)	
                .style('transform', `translate(${x}px, ${y}px)`);
              })					
              .on("mouseout", function(evt, d) {	//on mouse out hide tooltip	
                div.transition()		
                   .duration(500)		
                   .style("visibility", "hidden");	
              })
              .on("click", function(evt, d){ //on mouse click go to historico procesos
                window.open('#/historicoProcesos/' + d.idHistorico_piezas + "/" + d.idHistoricoOperacion + "/" + scope.myFunctions.dateToYYYY_MM_DD(scope.fechaIni) + '/' + scope.myFunctions.dateToYYYY_MM_DD(scope.fechaFin) + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0', '_blank');
              });
    }

  }

  cellClick(e: any): void{ //si se clica en la row
    if (e.columnIndex === 11){ //solo si es la columna del histórico
      // filtro fechas
      var fini = this.myFunctions.dateToYYYY_MM_DD(this.fechaIni); //FORMATO: YYYY_MM_DD
      var ffin = this.myFunctions.dateToYYYY_MM_DD(this.fechaFin); //FORMATO: YYYY_MM_DD

      if (!this.user.ocultarParte){
        var filtrado= this.dataFiltro.filter(function(elem) {return elem.nombreOf === e.dataItem.numeroOF && elem.nombreOperacion === e.dataItem.nombreOperacion 
          && elem.nombrePieza === e.dataItem.nombrePieza && elem.nombreParte === e.dataItem.nombreParte;});
        //ir al histórico
        window.open('#/historicoPiezas/' + fini + '/' + ffin + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + filtrado[0].idOf + '/' + filtrado[0].idCliente + '/' + filtrado[0].idPieza + '/' + filtrado[0].idParte + '/' + '0', '_blank');
      } else{
        var filtrado= this.dataFiltro.filter(function(elem) {return elem.nombreOf === e.dataItem.numeroOF && elem.nombreOperacion === e.dataItem.nombreOperacion 
          && elem.nombrePieza === e.dataItem.nombrePieza;});
        //ir al histórico
        window.open('#/historicoPiezas/' + fini + '/' + ffin + '/' + '0' + '/' + '0' + '/' + '0' + '/' + '0' + '/' + filtrado[0].idOf + '/' + filtrado[0].idCliente + '/' + filtrado[0].idPieza + '/' + '0' + '/' + '0', '_blank');
      }
      
    }
  }

}
